module.exports = __webpack_public_path__ + "img/icon-show-group-1.e262b97b.svg";